/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  HERC1155Logic,
  HERC1155LogicInterface,
} from "../../../../contracts/dependant/erc1155/HERC1155Logic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type HERC1155LogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: HERC1155LogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class HERC1155Logic__factory extends ContractFactory {
  constructor(...args: HERC1155LogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<HERC1155Logic> {
    return super.deploy(overrides || {}) as Promise<HERC1155Logic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): HERC1155Logic {
    return super.attach(address) as HERC1155Logic;
  }
  override connect(signer: Signer): HERC1155Logic__factory {
    return super.connect(signer) as HERC1155Logic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): HERC1155LogicInterface {
    return new utils.Interface(_abi) as HERC1155LogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): HERC1155Logic {
    return new Contract(address, _abi, signerOrProvider) as HERC1155Logic;
  }
}
